<template>
  <div class="std-background">
    <v-card width="500" class="mx-auto my-3">
      <!-- Unsuccessful booking -->
      <template v-if="(results.length != 0) && resultAction == 'unsuccessfulBooking'">
        <div class="std-title std-title--no-bg text-center">
          <img :src="require('@/assets/unsuccessful.png')" width="75" class="pb-5"/>
          <h2>Oops!<br>Looks like {{representativeBooking ? "she's" : "you're"}} not quite ready yet</h2>
        </div>
        <div class="std__content" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
          <ol class="primaryLight--text">
            <li v-for="result in results" :key="result.id">
              <b>{{representativeBooking ? result.representativeTitle : result.selfTitle}}</b>
              <p>{{result.description}}</p>
            </li>
          </ol>
        </div>
      </template>

      <!-- Successful booking -->
      <template v-if="resultAction == 'successfulBooking'">
        <div class="std-title std-title--no-bg text-center">
          <img :src="require('@/assets/successful.png')" width="75" class="pb-5" />
          <h2>Booking success!</h2>
        </div>
        <div class="std__content" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
          <p>Last few things to take note...</p>
          <ol class="grayWording--text">
            <li><p>Booking is on a first come, first serve basis following the announcement of available dates on my Instagram.</p></li>
            <li><p>Please be on time as $5 fee will be charged for every 5 minutes late from the mutually agreed time.</p></li>
            <li><p>Practitioner would have the right to cancel and replace a new substitution date in case of  unforeseen circumstances.</p></li>
            <li><p>Clients have the right to cancel their appointment at least 24hrs before the booked date and time.</p></li>
          </ol>
        </div>

      </template>

      <!-- Consultation -->
      <template v-if="resultAction == 'consultation'">
        <div class="std-title std-title--no-bg text-center">
          <img :src="require('@/assets/successful.png')" width="75" class="pb-5" />
          <h2>Thank you for consulting<br>with Dr Asmah!</h2>
        </div>
        <div class="std__content" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
          <p>She is already notified of your WhatsApp message and will get back to you shortly.</p>
        </div>
      </template>

      <div v-if="(results.length == 0) && resultAction == 'unsuccessfulBooking'" class="pt-5 px-5">
        <v-alert outlined dense type="warning" class="py-5" prominent>
          <h4 class="warning--text">Seems like you have exited the page.</h4>
          <router-link to="/checklist" class="warning--text">Please retake the assessment!</router-link>
        </v-alert>
      </div>

      <!-- DM or Return to homepage-->
      <div class="text-center px-5">
        <div v-if="resultAction == 'unsuccessfulBooking'">
          <p>If you wish to learn more about {{representativeBooking ? 'her' : 'your'}} condition, please click on the Instagram widget and send me a DM!</p>
        </div>
        <div v-if="resultAction != 'unsuccessfulBooking'">
          <p>Please click on the Instagram widget and<br>DM me if you have further questions!</p>
        </div>
        <div class="pt-5 pb-5"><span class="results__or text-center grayWording--text">OR</span></div>
        <div class="mb-10">
          <v-btn depressed color="primaryLight" class="white--text" href="https://drasmahhealthhub.com">Return to home page</v-btn>
        </div>
      </div>

      <!-- Instagram DM Footer-->
      <v-card-actions>
        <v-col cols="9">
          <v-card class="mx-auto rounded-lg">
            <v-card-text class="primaryLight--text px-3 py-3">
              <div v-if="resultAction == 'unsuccessfulBooking'">Please click here to contact Dr. Asmah for further consultation!</div>
              <div v-if="resultAction != 'unsuccessfulBooking'">Please click here to contact Dr. Asmah for further inquiries!</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <a href="https://www.instagram.com/drasmah_healthhub">
            <v-img :src="require('@/assets/instagram.png')"></v-img>
          </a>
        </v-col>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'ChecklistResults',
    mounted() {
      this.representativeBooking = this.$store.state.representativeBooking
      this.results = this.$store.state.checkedResults
      switch (this.$route.query.status) {
        case 'red':
          this.resultAction = 'unsuccessfulBooking'
          break
        case 'green':
          this.resultAction = 'successfulBooking'
          break
        default:
          this.resultAction = 'consultation'
      }
    },
    data() {
      return {
        resultAction: '',
        representativeBooking: false,
        results: []
      }
    }
  }
</script>